export default __webpack_public_path__ + "static/media/pastor-arm.df5d7bfd.jpg";